import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { getAssessmentReport, viewUserFeedback } from "../../../../Redux/Slices/User/userSlice";
import "./styles.scss";
import CardHero from "Components/CardHero";
import DropdownDetails from "Components/DropdownDetails";
import MainLayout from "Layouts/Main";
import { useEffect } from "react";
import moment from "moment";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import BackArrow from "../../../../Assets/Svg/Auth/BackArrow.svg";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { getSpareParts } from '../../../../Redux/Slices/Accessor/accessorSlice';
import { addSparePartEntry, clearAllSparePartEntries, updateSparePartField } from "../../../../Redux/Slices/Accessor/sparePartUploaderSlice";


function ReportsDetails() {
  const navigate = useNavigate();
  const { reportId } = useParams();
  const [feedbackData, setFeedbackData] = useState([])

  const dispatch = useDispatch();

  const [reportData, setReportData] = useState(null);
  const [sparePartData, setSparePartData] = useState(null);
  const isloading = useSelector((state) => state.user.isLoading);
  useEffect(() => {
    dispatch(
      getAssessmentReport({ reportId, callBack: setReportDataAndLoading })
    );
    dispatch(
      viewUserFeedback({
        data: {
          backlog_id: reportId,
          isUser: "false",
        },
        callBack: (data) => {
          console.log("API response:", data);
          setFeedbackData(data.data.data);
        },
      })
    );
    dispatch(
      getSpareParts({ assessment_id: reportId, callBack: setSparePartDataAndLoading })
    )
  }, []);


  const setReportDataAndLoading = (data) => {
    setReportData(data);
  };

  const setSparePartDataAndLoading = (data) => {
    setSparePartData(data)
  }

  return (
    <>
      <MainLayout>
        <div className="a-assessment-container">
          <div className="d-flex align-items-center"
            onClick={() => {
              navigate(-1); //
            }}
            style={{ cursor: "pointer" }}>
            <img
              src={BackArrow}
              alt="backarrow"
              width="18px"
              height="18px"

              style={{
                marginLeft: "-5px",
                marginBottom: "-10px",
                cursor: "pointer",
              }}
            />
            <h1 className="report-container-breadcrumb">Back to Reports</h1>
          </div>
          {isloading === 'loading' ?
            <Skeleton height={200} count={1} />
            :
            <CardHero
              headingName={
                reportData?.data?.assessment_details?.assessment_name || "N/A"
              }
              assessorName={
                reportData?.data?.assessment_details?.assessor_name || "N/A"
              }
              approverName={
                reportData?.data?.assessment_details?.approver_name || "N/A"
              }
              approvedOn={
                reportData?.data?.assessment_details?.approved_on
                  ? moment(
                    reportData?.data?.assessment_details?.approved_on
                  ).format("DD-MM-YYYY")
                  : "-"
              }
              overallRating={reportData?.data?.overall_average_score || "N/A"}
            />}
          {isloading === 'loading' ? (
            <Skeleton height={170} count={5} style={{ marginBottom: "15px" }} />
          ) : (
            <>
              {feedbackData?.length > 0 && (
                <div className="view-feedback">
                  <h3>Feedback</h3>

                  {feedbackData.map((feedback, idx) => (
                    <div key={idx}>
                      <div className="d-flex align-items-center gap-2 heading mb-1">
                        Rating:&nbsp;
                        {[...Array(5)].map((_, starIdx) =>
                          starIdx < (feedback?.user_rating || 0) ? (
                            <AiFillStar key={starIdx} className="text-warning" />
                          ) : (
                            <AiOutlineStar key={starIdx} className="text-secondary" />
                          )
                        )}
                      </div>

                      <div className="text-muted">User Name: {feedback?.user_name}</div>
                      <div>{feedback?.user_feedback}</div>
                    </div>
                  ))}
                </div>
              )}

              {reportData?.data?.performance_results.map((performance) => (
                <DropdownDetails
                  key={performance.category_id}
                  headingName={performance?.category_name || "Unknown Category"}
                  details={`Click "View Details" to access a comprehensive module-wise breakdown of your scores.`}
                  perfomanceRating={performance?.average_score || "N/A"}
                  performanceScore="65"
                  scoresData={performance?.sub_categories.map((subCategory) => ({
                    heading: subCategory?.subCategory_name,
                    score: subCategory?.average_score,
                  }))}
                  assessmentId={reportId}
                  score="100%"
                  isSparePart = {false}
                  handleViewDetails={() =>
                    navigate(
                      `/reports/report-details/Assessment/${reportId}/${performance.category_id}`
                    )
                  }
                />
              ))}
              {/* {sparePartData?.length > 0 &&
                sparePartData?.map((performance) => (
                  <DropdownDetails
                    key={performance.log_id}
                    headingName={performance?.category_name || "Spare Parts"}
                    details={`Click "View Details" to access a comprehensive module-wise breakdown of your scores.`}
                    perfomanceRating={performance?.average_score || "0"}
                    assessmentId={reportId}
                    isSparePart={true}
                    handleViewDetails={() =>
                      navigate(
                        `/reports/report-details/Assessment/${reportId}/${performance.log_id}`
                      )
                    }
                  />
                ))} */}
            </>
          )}
        </div>
      </MainLayout>
    </>
  );
}

export default ReportsDetails;
